import React, { useEffect, useState } from "react";
import styles from "./AccountDetailsPage.module.css";
import {
  setButtonAction,
  setHeader,
  setUpdateButtonDisabled,
} from "../../reduxSlices/headerSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import ButtonCta1 from "../../components/button/ButtonCta1";
import { Service } from "../../services/service";
import {
  BASE_URL,
  CLIENT_ADMIN_ROLE_ID,
  OCP_APIM_SUBSCRIPTION_KEY,
  USER_ROLE_ID,
  VF_ADMIN_ROLE_ID,
  toastConfig,
  CLIENT_ID,
  REDIRECT_URI,
} from "../../constants/constant";
import { toast } from "react-toastify";
import { getUserLogin } from "../../reduxSlices/userSlice";
import { AuthContext } from "react-oauth2-code-pkce";
import { useContext } from "react";
import { ReactComponent as LogoutIcon } from "../../assets/images/Logout.svg";
import { ReactComponent as SwapIcon } from "../../assets/images/Swap.svg";
import { useNavigate } from "react-router-dom";
import CommonDialog from "../../components/dialog/CommonDialog";
import SwitchEnvDialog from "../../components/dialog/SwitchEnvDialog";
import { CustomTextField } from "../../helpers/helper";
import ImageUploader from "../../components/imageuploader/ImageUploader";
import axios from "axios";
import { validateName } from "../../helpers/helper";


const service = new Service();

const AccountDetailsPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [value, setValue] = useState("");
  const [open, setOpen] = useState(false);
  const [logoutClicked, setLogoutClicked] = useState(false);
  const [user, setUser] = useState({
    userId: "",
    emailId: "",
    familyName: "",
    givenName: "",
    organization: {},
    isActive: true,
    isAdmin: true,
    roles: [],
    isValidFamilyName: false,
  });
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [profileData, setProfileData] = useState({
    userId: "",
    profileImage: null,
    isRemoveProfileImage: null,
  });
  const [userEnvironments, setUserEnvironments] = useState([]);
  const [selectUserEnvironment, setSelectUserEnvironment] = useState(null);
  const userRole = useSelector((state) => state?.user?.userRoleId);
  const currentUser = useSelector((state) => state?.user?.currentUser?.data);
  const buttonAction = useSelector((state) => state?.header?.buttonAction);
  const searchParams = localStorage.getItem("searchParams");
  const isClientUser = userRole?.includes(USER_ROLE_ID);
  const isClientAdmin = userRole?.includes(CLIENT_ADMIN_ROLE_ID);
  const isVFAdmin = userRole?.includes(VF_ADMIN_ROLE_ID);
  const [openSwitchEnvDialog, setOpenSwitchEnvDialog] = useState(false);
  const { logOut } = useContext(AuthContext);
  const { login } = useContext(AuthContext);
  console.log("logOut>>>>", logOut);

  const handleInputFocus = () => {
    console.log("User clicked on the input text.");
    dispatch(setUpdateButtonDisabled(true));
  };

  const handleClickOpen = () => {
    setLogoutClicked(false);
    setOpen(true);
  };

  const handleLogoutOpen = () => {
    setLogoutClicked(true);
    setOpen(true);
  };

  const handleLoginAs = () => {
    if (searchParams === "/admin" && !isClientUser)
      navigate("/accessdenied");
    if (searchParams === "/admin") {
      localStorage.setItem("searchParams", "/");
      navigate("/dashboard");
    } else
      navigate("/admin");
  };

  const handleCancel = () => {
    setOpen(false);
    setLogoutClicked(false);
  };

  const handleGoBack = () => {
    // setOpen(false);
    navigate("/dashboard");
    setLogoutClicked(false);
  };

  // const handleChange = (event) => {
  //   setValue(event.target.value);
  // };

  useEffect(() => {
    console.log("user>>>>", user);
    const fetchUserData = async () => {
      if (user.userId) {
        let url = `/api/User/GetUserById`;
        const user_token = localStorage.getItem("bb_access_token");
        try {
          let data = await service.newGetApi(url, { id: user.userId }, user_token);
          let resp = data.data;
          let userenvironments = resp.environments;
          setUserEnvironments(userenvironments);
          //let emailId = resp.emailId;
        } catch (err) {
          console.log(err);
        }
      }
    }
    fetchUserData();
  }, [user]);

  useEffect(() => {
    setValue(userRole?.includes(USER_ROLE_ID) ? "standard" : "admin");
  }, [userRole]);

  useEffect(() => {
    setUser({
      userId: currentUser?.userId,
      emailId: currentUser?.emailId,
      familyName: currentUser?.familyName,
      givenName: currentUser?.givenName,
      organization: currentUser?.organization,
      isActive: currentUser?.isActive,
      isAdmin: currentUser?.isAdmin,
      roles: currentUser?.roles,
    });
    setImageUrl(currentUser?.profileImage);
    // setProfileData({ ...profileData, userId: currentUser?.userId });
  }, [currentUser]);

  useEffect(() => {
    setProfileData({
      ...profileData,
      userId: currentUser?.userId,
      profileImage: selectedFile,
      isRemoveProfileImage: imageUrl ? false : true,
    });
  }, [selectedFile, imageUrl]);

  console.log("currentUser", currentUser, profileData);

  useEffect(() => {
    dispatch(
      setHeader({
        page: "my-account",
        title: "My Account",
        subTitle:
          "Update your details and contact Visualise or your organisation admin in case of access update",
      })
    );
  }, []);

  useEffect(() => {
    if (
      buttonAction.page === "my-account" &&
      buttonAction.action === "update"
    ) {
      console.log("buttonAction called");
      handleSubmit();
    }
    if (
      buttonAction.page === "my-account" &&
      buttonAction.action === "cancel"
    ) {
      console.log("buttonAction called");
      handleClickOpen();
    }
    dispatch(
      setButtonAction({
        page: "",
        action: "",
      })
    );
  }, [buttonAction.page, buttonAction.action]);

  const handleOrganizationChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  const handleSubmit = (e) => {
    updateUser();
  };

  const handleLogout = () => {
    console.log("logout called");
    localStorage.clear();
    navigate("/login");
    // logOut();
  };

  const updateProfileImage = async () => {
    const formData = new FormData();
    formData.append("UserId", profileData.userId);
    formData.append("ProfileImage", profileData.profileImage);
    formData.append("isRemoveProfileImage", profileData.isRemoveProfileImage);
    let url = `${BASE_URL}/api/User/SaveUserProfile`;
    const user_token = localStorage.getItem("bb_access_token");
    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
        "Ocp-Apim-Subscription-Key": OCP_APIM_SUBSCRIPTION_KEY,
        Authorization: "Bearer  " + user_token,
      },
    };
    try {
      let response = await axios.post(url, formData, config);
      let resp = response?.data?.data;
      let emailId = resp.emailId;
      console.log("resp<><>", resp);
      if (emailId) {
        const obj = {
          email: emailId,
        };
        dispatch(getUserLogin(obj));
      }
    } catch (err) {
      console.log(err);
      toast.error(err.message, toastConfig);
    }
  };

  const updateUser = async () => {
    if (user.isValidFamilyName) {
      setIsButtonClicked(false);
      let url = `/api/User/UpdateUser`;
      const user_token = localStorage.getItem("bb_access_token");
      const userData = prepareUserData();
      const formData = JSON.stringify(userData);
      try {
        let data = await service.newPutApi(url, formData, user_token);
        const response = await updateProfileImage();
        let resp = data.data;
        let emailId = resp.emailId;
        console.log("resp<<<", resp, response);
        if (emailId) {
          const obj = {
            email: emailId,
          };
          dispatch(getUserLogin(obj));
        }
        if (resp?.data && resp?.success) {
          toast.success("Your account details has been updated!", {
            ...toastConfig,
            style: {
              backgroundColor: "#4a67ad",
            },
          });
          navigate("/dashboard");
          dispatch(setUpdateButtonDisabled(false));
          setUser({ emailId: "", familyName: "", givenName: "" });
        } else {
          toast.warning(resp?.errorMessage, toastConfig);
        }
      } catch (err) {
        console.log(err);
        toast.error(err.message, toastConfig);
      }
    }
    else {
      setIsButtonClicked(true);
    }
  };

  const client_id = CLIENT_ID;
  const redirectUri = REDIRECT_URI;
  const updateUserEnv = async (updatedUser) => {
    setIsButtonClicked(false);
    let url = `/api/User/UpdateUser`;
    const user_token = localStorage.getItem("bb_access_token");
    const userData = updatedUser;
    const formData = JSON.stringify(userData);
    try {
      let data = await service.newPutApi(url, formData, user_token);
      const response = await updateProfileImage();
      let resp = data.data;
      let emailId = resp.emailId;
      if (emailId) {
        const obj = {
          email: emailId,
        };
        dispatch(getUserLogin(obj));
      }
      if (resp?.data && resp?.success) {
        localStorage.setItem("environment_id", selectUserEnvironment?.environmentId);
        localStorage.setItem("isSwitchEnv", true);
        const url = `https://app.blackbaud.com/oauth/authorize?response_type=code&client_id=${client_id}&redirect_uri=${redirectUri}&environment_id=${selectUserEnvironment?.environmentId}`;
        window.open(url, `_self`);
      } else {
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      toast.error(err.message, toastConfig);
    }
  }

  const prepareUserData = () => {
    return {
      userId: user?.userId,
      emailId: user?.emailId,
      familyName: user?.familyName,
      givenName: user?.givenName,
      organization: user?.organization,
      isActive: user?.isActive,
      isAdmin: user?.isAdmin,
      roles: user?.roles,
    };
  };

  useEffect(() => {
    const isFamilyNameValid = validateName(user.familyName);
    if (user.familyName) {
      setUser({ ...user, isValidFamilyName: isFamilyNameValid });
    }
  }, [user.familyName]);

  const handleSwitchEnvClick = () => {
    setOpenSwitchEnvDialog(true);
  };

  const handleSwitchEnvConfirm = async () => {
    if (selectUserEnvironment?.environmentId != currentUser?.environments[0]?.environmentId) {
      const updatedUser = {
        ...user,
        organization: {
          organizationId: selectUserEnvironment.organizationId,
          organizationName: ""
        },
      };
      await updateUserEnv(updatedUser);
    }
    setOpenSwitchEnvDialog(false);
  };
  const handleAutoCompleteChange = (name, value) => {
    setSelectUserEnvironment({ ...value });
  };
  const getEnvLabel = (option) => {
    return option.environmentName === currentUser?.environments[0]?.environmentName
    ? `${option.environmentName} (current)`
    : option.environmentName;
  }
  return (
    <>
      <div className={styles.formContainer}>
        <ImageUploader
          handleInputFocus={handleInputFocus}
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
          imageUrl={imageUrl}
          setImageUrl={setImageUrl}
          bgColor="#f5f5f5"
        />
        <Box
          component="form"
          sx={{
            "& > :not(style)": {},
          }}
          noValidate
          autoComplete="off"
        >
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "40px",
              }}
            >
              <label style={labelStyle}>
                First Name<sup style={requiredAr}>*</sup>
              </label>
              <CustomTextField
                disabled
                id="outlined-basic"
                variant="outlined"
                type="text"
                name="givenName"
                sx={{ width: "240px", backgroundColor: "#efefef" }}
                value={user.givenName}
                onChange={handleOrganizationChange}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "40px",
                marginBottom: "40px",
              }}
            >
              <label style={labelStyle}>Last Name (Optional)</label>
              <CustomTextField
                id="outlined-basic"
                variant="outlined"
                type="text"
                name="familyName"
                sx={{ width: "240px" }}
                value={user.familyName}
                onChange={handleOrganizationChange}
                onFocus={handleInputFocus}
              />
              {user?.familyName && !user?.isValidFamilyName && isButtonClicked && (
                <Typography
                  sx={{
                    color: "red",
                    fontSize: "14px",
                    fontWeight: 500,
                    fontFamily: "Montserrat",
                  }}
                >
                  Text is not valid.
                </Typography>
              )}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "40px",
            }}
          >
            <label style={labelStyle}>
              Email<sup style={requiredAr}>*</sup>
            </label>
            <CustomTextField
              disabled
              id="outlined-basic"
              variant="outlined"
              type="text"
              name="emailId"
              sx={{ width: "520px", backgroundColor: "#efefef" }}
              value={user.emailId}
              onChange={handleOrganizationChange}
            />
          </Box>
          {/* <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "end",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <label style={labelStyle}>
                Access<sup style={requiredAr}>*</sup>
              </label>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={value}
                  onChange={handleChange}
                >
                  {userRole?.includes(USER_ROLE_ID) && (
                    <>
                      <FormControlLabel
                        disabled
                        value="standard"
                        control={<Radio />}
                        label="Standard"
                      />
                      <Typography sx={typoStyle}>
                        Standard user can review reports based on the package and
                        data translation settings
                      </Typography>
                    </>
                  )}
                  {!userRole?.includes(USER_ROLE_ID) && (
                    <>
                      <FormControlLabel
                        disabled
                        value="admin"
                        control={<Radio />}
                        label="Admin"
                      />
                      <Typography sx={typoStyle}>
                        Admin can manage users, data translation settings and
                        review reports based on the package
                      </Typography>
                    </>
                  )}
                </RadioGroup>
              </FormControl>
            </Box>
          </Box> */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "end",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <label style={{ ...labelStyle, marginBottom: "20px" }}>
                Access<sup style={requiredAr}>*</sup>
              </label>
              {userRole?.includes(VF_ADMIN_ROLE_ID) && (
                <>
                  <Typography
                    sx={{
                      ...typoStyle,
                      fontSize: "16px",
                      color: "#5a5a5a",
                      marginBottom: "5px",
                    }}
                  >
                    Visualise Admin
                  </Typography>
                  <Typography sx={typoStyle}>
                    You can manage users, organisations, reports, packages, data
                    translation settings, etc.
                  </Typography>
                </>
              )}
              {userRole?.includes(CLIENT_ADMIN_ROLE_ID) && (
                <>
                  <Typography
                    sx={{
                      ...typoStyle,
                      fontSize: "16px",
                      color: "#5a5a5a",
                      marginBottom: "5px",
                    }}
                  >
                    Admin
                  </Typography>
                  <Typography sx={typoStyle}>
                    You can manage users, data translation settings and review
                    reports based on the package.
                  </Typography>
                </>
              )}
              {userRole?.includes(USER_ROLE_ID) && (
                <>
                  <Typography
                    sx={{
                      ...typoStyle,
                      fontSize: "16px",
                      color: "#5a5a5a",
                      marginBottom: "5px",
                    }}
                  >
                    Standard
                  </Typography>
                  <Typography sx={typoStyle}>
                    You can review reports based on the package and data
                    translation settings.
                  </Typography>
                </>
              )}
              {(isClientAdmin || isVFAdmin) && (
                <Box
                  sx={{
                    marginTop: "5px",
                  }}
                >
                  <ButtonCta1
                    text={
                      searchParams === "/admin"
                        ? "Login as Client User"
                        : "Go to Admin Console"
                    }
                    onClick={handleLoginAs}
                    variant="outlined"
                    disabled={false}
                    startIcon={<SwapIcon />}
                    color="#f7954c"
                    bgColor="#fff"
                    height="48px"
                  />
                  {(searchParams === "/admin" && userEnvironments.length > 1) && (
                    <ButtonCta1 sx={{ marginLeft: "15px" }}
                      text="Switch Environment"
                      onClick={handleSwitchEnvClick}
                      variant="outlined"
                      disabled={false}
                      startIcon={<SwapIcon />}
                      color="#f7954c"
                      bgColor="#fff"
                      height="48px"
                    />
                  )}
                </Box>
              )}
            </Box>
            <Box sx={{ marginRight: "-5px", marginBottom: "-8px" }}>
              <ButtonCta1
                text="Logout"
                onClick={handleLogoutOpen}
                variant="text"
                disabled={false}
                endIcon={<LogoutIcon />}
                color="#a50218"
              />
            </Box>
          </Box>
          {/* <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex" }}>
              <Box sx={{ marginRight: "20px" }}>
                <ButtonCta1
                  text="Cancel"
                  onClick={handleClickOpen}
                  variant="contained"
                  disabled={false}
                  bgColor="#e0e0e0"
                  color="#5a5a5a"
                />
              </Box>
              <Box>
                <ButtonCta1
                  text="Update"
                  onClick={() => handleSubmit()}
                  variant="contained"
                  disabled={false}
                />
              </Box>
            </Box>
            <Box sx={{ marginRight: "20px" }}>
              <ButtonCta1
                text="Logout"
                onClick={handleLogoutOpen}
                variant="text"
                disabled={false}
                // style={{ backgraundColor: "#e51818" }}
                endIcon={<LogoutIcon />}
                color="#a50218"
              />
            </Box>
          </Box> */}
        </Box>
      </div>
      <CommonDialog
        open={open}
        setOpen={setOpen}
        handleCancel={handleCancel}
        handleDone={logoutClicked ? handleLogout : handleGoBack}
        title={logoutClicked ? "Confirm logout" : "All changes will be lost"}
        subTitle={
          logoutClicked
            ? "Are you sure you want to logout from the platform? You’ll be returned to the login screen."
            : "Are you sure you want to discard changes?"
        }
        leftButtonText="Cancel"
        rightButtonText={logoutClicked ? "Logout" : "Discard"}
      />
      <SwitchEnvDialog
        open={openSwitchEnvDialog}
        onClose={() => setOpenSwitchEnvDialog(false)}
        onConfirm={handleSwitchEnvConfirm}
        organizationOptions={userEnvironments}
        organization={selectUserEnvironment}
        setOrganization={(value) => handleAutoCompleteChange("environment", value)}
        getOrgLabel={getEnvLabel}
        handleInputFocus={handleInputFocus}
      />
    </>
  );
};

export default AccountDetailsPage;

const labelStyle = {
  fontSize: "14px",
  letterSpacing: "-0.02em",
  fontWeight: 600,
  fontFamily: "Montserrat",
  color: "#282828",
  textAlign: "left",
  marginBottom: "8px",
};

const requiredAr = {
  color: "#CF4500",
  fontSize: "13px",
  verticalAlign: "baseline",
};

const typoStyle = {
  fontSize: "12px",
  letterSpacing: "-0.02em",
  lineHeight: "16px",
  fontWeight: 500,
  fontFamily: "Montserrat",
  color: "#8a8a8a",
  textAlign: "left",
  display: "inline-block",
  width: "auto",
  marginBottom: "10px",
};
